import { render, staticRenderFns } from "./contracts.vue?vue&type=template&id=4622291b"
import script from "./contracts.vue?vue&type=script&lang=js"
export * from "./contracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports